import { gql } from '@grandvisionhq/graphql';
import { address } from './address.js';
import { discount } from './discount.js';
import { legacyProduct } from './legacy-product.js';
import { lineItemBundle } from './line-item-bundle.js';
import { lineItemPrice } from './line-item-price.js';
import { contactLensBundleBeneluxTypeDetails } from './type-details/contact-lens-bundle-benelux.js';
import { contactLensSubscriptionTypeDetails } from './type-details/contact-lens-subscription.js';
import { contactLensesTypeDetails } from './type-details/contact-lenses.js';
import { prescriptionGlassesTypeDetails } from './type-details/prescription-glasses.js';

const cartDetails = gql`
  fragment CartDetailsFragment on Cart {
    __typename
    id
    checkoutState
    customerDetails {
      email
      phone
      customerType
      dateOfBirth
    }
    invoiceDetails {
      certifiedEmail
      vatId
      certifiedRecipientCode
    }
    shippingAddress {
      ...AddressFragment
    }
    shippingMethod {
      id
      key
      freeAbove
    }
    billingAddress {
      ...AddressFragment
    }
    appliedDiscounts {
      name {
        locale
        value
        __typename
      }
      code
      requiresDiscountCode
      __typename
    }
    loyaltyDetails {
      cardNumber
      points
    }
    numberOfItems
    price {
      subtotal
      discount {
        amount
        percentage
        __typename
      }
      net
      gross
      tax {
        amount
        portions {
          rate
          amount
          __typename
        }
        __typename
      }
      shippingPrice
      paymentMethodPrice
      subscriptionPlanPrice {
        __typename
        invoicedAmount
        total
      }
      __typename
    }
    vouchers {
      code
      isActive
      name
      state
      __typename
    }
    subscriptionPlan {
      billingDate
      __typename
    }
    isAccountRequired
    additionalCartCostLineItems {
      id
      sku
      quantity
    }
    lineItems {
      id
      lineItemType
      typeDetails {
        ... on ContactLensBundleBeneluxTypeDetails {
          ...ContactLensBundleBeneluxTypeDetailsFragment
        }
        ... on ContactLensSubscriptionTypeDetails {
          ...ContactLensSubscriptionTypeDetailsFragment
        }
        ... on ContactLensesTypeDetails {
          ...ContactLensesTypeDetailsFragment
        }
        ... on BundlePrescriptionGlassesTypeDetails {
          ...PrescriptionGlassesTypeDetailsFragment
        }
      }
      isGift
      sku
      quantity
      discounts {
        ...DiscountFragment
      }
      price {
        ...LineItemPriceFragment
      }
      __typename
      ... on LineItemRegular {
        legacyProduct {
          ...LegacyProductFragment
          __typename
        }
        __typename
      }
      ... on LineItemContactLenses {
        legacyProduct {
          ...LegacyProductFragment
          __typename
        }
        __typename
      }
      ... on LineItemBundle {
        ...LineItemBundleFragment
      }
    }
  }
  ${address}
  ${contactLensBundleBeneluxTypeDetails}
  ${contactLensSubscriptionTypeDetails}
  ${contactLensesTypeDetails}
  ${prescriptionGlassesTypeDetails}
  ${legacyProduct}
  ${lineItemBundle}
  ${lineItemPrice}
  ${discount}
`;

export { cartDetails };
//# sourceMappingURL=cart-details.js.map
